import RawMarket from "./RawMarket";
import Accessory from "./Accessory";
import { useAmount } from "../contexts/amountContext";

const TotalCost = () => {
  const { handleSubmit } = useAmount();
  return (
    <div className="container">
      <form>
        <div className="row">
          <RawMarket />
          <Accessory />
        </div>

        <div className="row">
          <div className="col">
            <button
              type="submit"
              className="btn btn-primary w-100"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default TotalCost;
